export default __webpack_public_path__ + "static/media/jetPartner.33e7bb5a.svg";